// Shared bits for the Manager live-operations pages.
export const LiveBadge = ({ state }) => {
  const map = {
    live: ["#00E676", "LIVE"],
    stale: ["#FFD600", "STALE"],
    offline: ["#FF3B30", "OFFLINE"],
    engine_off: ["#9CA3AF", "ENGINE OFF"],
  };
  const [color, label] = map[state] || map.offline;
  return (
    <span className="inline-flex items-center gap-1.5 text-[11px] font-medium" style={{ color }} data-testid={`live-badge-${state}`}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: color, boxShadow: state === "live" ? `0 0 6px ${color}` : "none" }} />
      {label}
    </span>
  );
};

export const ago = (iso) => {
  if (!iso) return "never";
  const s = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.round(s / 60)}m ago`;
  return `${Math.round(s / 3600)}h ago`;
};

// Destructive-action confirmation dialog (used by Close-All / close-position controls).
export const ConfirmModal = ({ open, title, body, confirmLabel = "Confirm", busy, onConfirm, onCancel }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 p-4" data-testid="confirm-modal" onClick={onCancel}>
      <div className="card-dark w-full max-w-sm p-6" onClick={(e) => e.stopPropagation()}>
        <p className="text-lg text-white mb-2">{title}</p>
        <p className="text-sm text-gray-400 mb-6">{body}</p>
        <div className="flex gap-3">
          <button data-testid="confirm-cancel" onClick={onCancel} disabled={busy} className="btn-outline flex-1 py-2.5 text-sm disabled:opacity-50">Cancel</button>
          <button data-testid="confirm-ok" onClick={onConfirm} disabled={busy}
            className="flex-1 py-2.5 text-sm rounded-lg font-medium bg-[#FF3B30] text-white hover:bg-[#ff5147] transition-colors disabled:opacity-50">
            {busy ? "Working…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
